import React from 'react';
import YouTube from 'react-youtube';

export class YoutubePlayer extends React.Component {
    state = {
        width: window.innerWidth,
        height: window.innerHeight - 10,
    };

    videoOptions = {
        width: this.state.width,
        height: this.state.height,
        playerVars: {
            autoplay: 1,
            modestbranding: 1,
            autohide: 1,
            showinfo: 0,
            controls: 0,
            loop: 1,
            playlist: this.props.url,
        },
    };

    // componentDidMount() {
    //     window.addEventListener('resize', this.handleResize);
    // }

    // componentWillUnmount() {
    //     window.removeEventListener('resize', this.handleResize);
    // }

    // handleResize = () => {
    //     this.setState({ width: window.innerWidth, height: window.innerHeight - 10 });
    // };

    videoEvent = {};

    componentDidUpdate(prevProps) {
        if (prevProps.currentSlide !== this.props.currentSlide) {
            if (this.props.currentSlide !== this.props.index) {
                this.pause(this.videoEvent);
            }

            if (this.props.currentSlide === this.props.index) {
                this.play(this.videoEvent);
            }
        }
    }

    onReady = event => {
        this.videoEvent = event;
    };

    pause = event => {
        event.target.pauseVideo();
    };

    play = event => {
        event.target.playVideo();
    };

    render() {
        const { url } = this.props;

        return (
            <div style={{ width: '100vw', height: '100vh' }}>
                {/* <iframe
                    type={'text/html'}
                    width={'100%'}
                    className={'youtube-video'}
                    height={'100%'}
                    src={videoUrl}
                    frameBorder="0"
                    allow="autoplay"
                /> */}
                <YouTube style={{ width: '100%' }} opts={this.videoOptions} videoId={url} onReady={this.onReady} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/UI/Containers/GymAdminPanel/GymTv/ChannelDisplay/YoutubePlayer.js